<div class="modal-header ">
  <p class="modal-title" id="title"><strong>{{header}}</strong></p>

    <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

</div>
<div class="modal-body">
  <div class="col-md-12">
    <div class="col-md-6">{{message}}</div>
    <div class="col-md-2"> <input type="number" class="form-control" min="0" max="100" [(ngModel)]="noofcopies" spellcheck="true" required /></div>    
    </div>
  <div class="col-12 text-center mt-3">
    <button class="btn btn-outline-primary mr-2" (click)="modal.dismiss()">Cancel</button>
    <button class="btn btn-secondary" [disabled]="!isNumber()" (click)="modal.close({'noofCopies':noofcopies})">Confirm</button>

  </div>
</div>
